// DV: human names, groups and variable labels for WhatsApp templates (account 1).

export const DV_WA_TEMPLATE_GROUPS = [
  { key: 'all', label: 'Все' },
  { key: 'trip', label: 'Выезд и гид' },
  { key: 'confirm', label: 'Подтверждение' },
  { key: 'payment', label: 'Оплата и брони' },
  { key: 'other', label: 'Прочее' },
];

const TEMPLATE_META = {
  pickup_time_standard: { title: 'Время сбора', group: 'trip' },
  pickup_time_standard_guides: { title: 'Время сбора (от гида)', group: 'trip' },
  car_number: { title: 'Номер машины', group: 'trip' },
  car_number_4242: { title: 'Номер машины (старый)', group: 'trip' },
  guide_tracking_started: { title: 'Гид начал сбор — карта', group: 'trip' },
  guide_reception: { title: 'Гид ждёт на ресепшене', group: 'trip' },
  guide_delay_notice: { title: 'Гид задерживается 5–7 минут', group: 'trip' },
  dalat_1_departure: {
    title: 'Далат 1 день: выезд',
    group: 'trip',
    variables: { 4: 'Остаток к оплате' },
  },
  dalat_1_departure_guides: { title: 'Далат: напоминание о выезде', group: 'trip' },
  tour_confirmation: { title: 'Подтверждение заявки', group: 'confirm' },
  tour_conformation: { title: 'Подтверждение заявки (дубль)', group: 'confirm' },
  tour_confirmation_tomorrow: { title: 'Подтверждение поездки на завтра', group: 'confirm' },
  tour_confirmation_d2_followup: { title: 'Напоминание: подтвердите бронь', group: 'confirm' },
  payment_reminder: {
    title: 'Напоминание об оплате',
    group: 'payment',
    variables: { 3: 'Тур', 4: 'Дата тура', 6: 'Оплатить до' },
  },
  vinpearl_booking_code: { title: 'Код бронирования Vinpearl', group: 'payment' },
  vinpearl_confirmation: { title: 'Код Vinpearl (подтверждение)', group: 'payment' },
  hello_client: { title: 'Приветствие клиенту', group: 'other' },
};

// Meta's sample template; never useful to managers.
const HIDDEN_TEMPLATES = ['hello_world'];

export const isDvTemplateVisible = template =>
  !HIDDEN_TEMPLATES.includes(template?.name);

const humanize = name => {
  const text = String(name || '').replace(/[_-]+/g, ' ').trim();
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : 'Шаблон';
};

export const dvTemplateTitle = template =>
  TEMPLATE_META[template?.name]?.title || humanize(template?.name);

export const dvTemplateGroup = template =>
  TEMPLATE_META[template?.name]?.group || 'other';

export const dvTemplateCategoryLabel = category => {
  const value = String(category || '').toUpperCase();
  if (value === 'MARKETING') return 'Маркетинг';
  if (value === 'AUTHENTICATION') return 'Код входа';
  return 'Сервисный';
};

const LABEL_RULES = [
  [/(здравствуйте|добрый день|привет)[,!\s]*$/i, 'Имя клиента'],
  [/(меня зовут)\s*$/i, 'Имя менеджера'],
  [/(заявк[аеиу]|заказ[ау]?|брон[ьи])\s*(№|#)?\s*$/i, 'Номер заявки'],
  [/на завтра,?\s*$/i, 'Дата'],
  [/поездк[аиу]\s*«?\s*$/i, 'Тур'],
  [/на\s*$/i, 'Дата'],
  [/(^|\s)в\s*$/i, 'Время'],
];

// "Тур: {{2}}" → "Тур"; "Здравствуйте, {{1}}" → "Имя клиента".
// Templates whose text gives no hint have explicit labels in TEMPLATE_META.
export const dvVariableLabel = (text, key, templateName = '') => {
  const explicit = TEMPLATE_META[templateName]?.variables?.[key];
  if (explicit) return explicit;
  const source = String(text || '');
  const index = source.indexOf(`{{${key}}}`);
  if (index > 0) {
    const before = source.slice(Math.max(0, index - 40), index);
    const colon = before.match(/([А-Яа-яЁёA-Za-z][А-Яа-яЁёA-Za-z ./-]{1,28}):\s*$/);
    if (colon) {
      const words = colon[1]
        .trim()
        .split(/\s+/)
        .filter(word => /[А-Яа-яЁёA-Za-z]/.test(word))
        .slice(-3)
        .join(' ');
      if (words) return words.charAt(0).toUpperCase() + words.slice(1);
    }
    const rule = LABEL_RULES.find(([pattern]) => pattern.test(before));
    if (rule) return rule[1];
  }
  return `Переменная ${key}`;
};

export const dvVariablePlaceholder = label => {
  switch (label) {
    case 'Имя клиента':
      return 'Например, Анна';
    case 'Номер заявки':
      return 'Например, 44495';
    case 'Дата':
    case 'Дата тура':
    case 'Дата выезда':
      return 'Например, 12 октября';
    case 'Время сбора':
    case 'Время выезда':
      return 'Например, 07:00';
    case 'Номер машины':
      return 'Например, 79B-123.45';
    default:
      return label;
  }
};
